import { render, staticRenderFns } from "./WorkspaceSearchBar.vue?vue&type=template&id=14b8f163&scoped=true"
import script from "./WorkspaceSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceSearchBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WorkspaceSearchBar.vue?vue&type=style&index=0&id=14b8f163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8f163",
  null
  
)

export default component.exports